import get from 'lodash/get';
import React from 'react';
import {FastField, ErrorMessage} from 'formik';
// import {FormattedMessage} from 'react-intl';
import classNames from 'classnames';
import messages from '../../../../res/translations/messages';
import Error from '../../Error';
import FormGroup from './FormGroup';

const ExclusiveChoiceType = ({form, name})=> (
    <div className="row">
        <FormGroup name={`${name}.exclusiveChoice.id`} label={messages.surveys.form.label.exclusiveChoice.id} size={3}>
            <FastField name={`${name}.exclusiveChoice.id`} id={`${name}.exclusiveChoice.id`} type="number"
                className={classNames('form-control',
                    {error: get(form.errors, `${name}.exclusiveChoice.id`) && get(form.touched, `${name}.exclusiveChoice.id`)})}
            />
            <ErrorMessage name={`${name}.exclusiveChoice.id`}>
                {(message) => <Error reason={message.key} reasonParams={message.params} />}
            </ErrorMessage>
        </FormGroup>
        <FormGroup name={`${name}.exclusiveChoice.value`} label={messages.surveys.form.label.exclusiveChoice.value} size={6}>
            <FastField name={`${name}.exclusiveChoice.value`} id={`${name}.exclusiveChoice.value`} type="text"
                className={classNames('form-control',
                    {error: get(form.errors, `${name}.exclusiveChoice.value`) && get(form.touched, `${name}.exclusiveChoice.value`)})}
            />
            <ErrorMessage name={`${name}.exclusiveChoice.value`}>
                {(message) => <Error reason={message.key} reasonParams={message.params} />}
            </ErrorMessage>
        </FormGroup>
    </div>
);

ExclusiveChoiceType.displayName = 'ExclusiveChoiceType';

export default ExclusiveChoiceType;
